import React, { useState, useEffect, useCallback } from 'react';
import { isEmpty } from 'lodash';
// import OfferwallSort from '../OfferwallSort';
import {
  OFFERWALL_TABS,
  SURVEYS_CONTAINER_CLASS_NAME,
  OFFERS_CONTAINER_CLASS_NAME,
} from '../../constants';

export default function OfferwallFilters() {
  const surveysEnabled = Pollfish.helper.getOfferwallSurveysEnabled();
  const offersEnabled = Pollfish.helper.getOfferwallOffersEnabled();
  const onlyOne =
    (surveysEnabled && !offersEnabled) || (!surveysEnabled && offersEnabled);

  const shouldShowDemographics =
    !Pollfish.demographics.isCompleted() &&
    !isEmpty(Pollfish.helper.json.tag_survey);
  const { getText } = Pollfish.ui;

  const [activeTab, setActiveTab] = useState(
    offersEnabled ? OFFERWALL_TABS.OFFERS : OFFERWALL_TABS.SURVEYS,
  );

  useEffect(() => {
    const page = $('body').attr('data-page');

    if (page === 'offerwall-offers') {
      document.querySelector(`.${SURVEYS_CONTAINER_CLASS_NAME}`).style.display =
        'none';
      if (Pollfish.offerwallPage.finishedOffersRequest) {
        Pollfish.ui.renderReactOfferwallOffersComponent();
      }
    } else {
      document.querySelector(`.${SURVEYS_CONTAINER_CLASS_NAME}`).style.display =
        'block';
      Pollfish.ui.unmountReactOfferwallOffersComponent();
    }
    setActiveTab(
      page === 'offerwall-offers'
        ? OFFERWALL_TABS.OFFERS
        : OFFERWALL_TABS.SURVEYS,
    );
  }, []);

  const selectTab = useCallback(
    (event, value) => {
      event.preventDefault();
      if (value === activeTab) {
        return;
      }

      Raven.captureBreadcrumb({
        message: 'changeOfferwallActiveTab',
        category: 'changeOfferwallActiveTab',
        data: {
          fromTab: activeTab,
          toTab: value,
        },
      });

      if (value === OFFERWALL_TABS.SURVEYS) {
        document.querySelector(
          `.${SURVEYS_CONTAINER_CLASS_NAME}`,
        ).style.display = 'block';
        document.querySelector(
          `.${OFFERS_CONTAINER_CLASS_NAME}`,
        ).style.display = 'none';
        Pollfish.ui.unmountReactOfferwallOffersComponent();
        $('body').attr('data-page', 'offerwall-surveys');
        if (shouldShowDemographics) {
          Pollfish.offerHeader.hide();
          Pollfish.sanity.setDisqualified(false);
          const contentSurveys = document.querySelector(
            `.${SURVEYS_CONTAINER_CLASS_NAME}`,
          );
          contentSurveys.innerHTML = Pollfish.ui.showUnlockScreen();
          Pollfish.offerwallPage.renderTerms();
          Pollfish.ui.renderLanguageSelect();
          Pollfish.event.getStarted();
        }
      }

      if (value === OFFERWALL_TABS.OFFERS) {
        document.querySelector(
          `.${SURVEYS_CONTAINER_CLASS_NAME}`,
        ).style.display = 'none';
        document.querySelector(
          `.${OFFERS_CONTAINER_CLASS_NAME}`,
        ).style.display = 'block';
        Pollfish.ui.renderReactOfferwallOffersComponent();
        $('body').attr('data-page', 'offerwall-offers');
      }

      setActiveTab(value);
    },
    [activeTab, shouldShowDemographics],
  );

  const classNames = `inline-block reset-button offerwall-filters-tab ${
    onlyOne ? 'offerwall-filters-tab-only-one' : ''
  }`;
  return (
    <header
      className="flex offerwall-filters"
      style={{ backgroundColor: '#fff' }}
    >
      <section className="flex flex-1 container flex-align-items--center">
        <div className="flex-1">
          {surveysEnabled && (
            <button
              className={`${
                activeTab === OFFERWALL_TABS.SURVEYS
                  ? 'offerwall-filters-tab-selected'
                  : ''
              } ${classNames}`}
              onTouchStart={(e) => selectTab(e, OFFERWALL_TABS.SURVEYS)}
              onClick={(e) => selectTab(e, OFFERWALL_TABS.SURVEYS)}
              type="button"
              data-testid="offerwall-filter-surveys"
            >
              {getText('offerwall.category.surveys')}
            </button>
          )}
          {offersEnabled && (
            <button
              className={`js-offerwall-offers-tab ${
                activeTab === OFFERWALL_TABS.OFFERS
                  ? 'offerwall-filters-tab-selected'
                  : ''
              } ${classNames}`}
              onTouchStart={(e) => selectTab(e, OFFERWALL_TABS.OFFERS)}
              onClick={(e) => selectTab(e, OFFERWALL_TABS.OFFERS)}
              type="button"
              data-testid="offerwall-filter-offers"
            >
              {getText('offerwall.category.offers')}
            </button>
          )}
        </div>
        {/* <div className="flex flex-align-items--center">
          {activeTab === OFFERWALL_TABS.SURVEYS && <OfferwallSort />}
        </div> */}
      </section>
    </header>
  );
}
